// extracted by mini-css-extract-plugin
module.exports = {"modal":"modalTag_modal__3XV9u","alert":"modalTag_alert__2Jim5","group":"modalTag_group__1CXmI","modalHeader":"modalTag_modalHeader__39npm"};